<template>
    <router-view></router-view>
</template>

<script>
    import Repository from '../../../repositories/sharing';
    import { mapMutations } from 'vuex';
    export default {
        name: "ShareLinkIndex",
        mounted() {
            this.init();
        },
        methods: {
            ...mapMutations(['setShare']),
            init() {
                let linkHash = this.$route.query.id;
                if(linkHash !== undefined) {
                    Repository.getShareLinkByUniqueHash(linkHash).then((response) => {
                        if (response.status < 400 && response.data != null && response.data.id !== undefined) {
                            let data = response.data;
                            let sharingDetails = {
                                id: data.user.id,
                                username: data.user.login,
                                imageUrl: data.user.imageUrl,
                                firstName: data.user.firstName,
                                lastName: data.user.lastName,
                                country: '',
                                allowComments: true,
                            };
                            this.setShare(sharingDetails);
                            this.$router.push('/book/shared');
                        } else
                            this.$router.push('/share/error');
                    });
                } else
                    this.$router.push('/share/error');
            },
        }
    }
</script>

<style scoped>

</style>
